<template>
  <div>
  </div>
</template>
<script>

export default ({
  name: 'Qrcode',
  data() {
    return{
      
    }
  },
  created(){
    if (/android/i.test(navigator.userAgent)) {
      console.log('Android');//这是Android平台下浏览器
      window.location.href = 'https://oss.0790jiaxiao.com/HS/apk/2.9.2/red_lionRelease-V2.9.2-9999.apk';
    } else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      console.log('IOS');//这是iOS平台下浏览器
      window.location.href = 'https://apps.apple.com/cn/app/id1598072476';
    };
    this.$emit('controlShow', true);
  },
  methods:{

  }
})
</script>

